import { render } from "./ReserveRight.vue?vue&type=template&id=4253f8d6"
import script from "./ReserveRight.vue?vue&type=script&lang=js"
export * from "./ReserveRight.vue?vue&type=script&lang=js"

import exportComponent from "/work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__